import type { TenantSummary } from '../../api/platformTenants';
import { Kpi } from '../Kpi';

interface Props { summary: TenantSummary; }

function relative(iso: string | null): string {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  const days = Math.floor(ms / (24 * 3600 * 1000));
  if (days < 1) return 'oggi';
  if (days < 30) return `${days}g fa`;
  const months = Math.floor(days / 30);
  return `${months}m fa`;
}

export function TenantKpiPanel({ summary }: Props) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
      <Kpi label="Warehouses"        value={String(summary.warehouses_count)} />
      <Kpi label="Tenant-admins"     value={String(summary.tenant_admins_count)} />
      <Kpi label="Voice supervisors" value={String(summary.voice_supervisors_count)} />
      <Kpi label="Operatori"         value={String(summary.operators_count)} />
      <Kpi label="Last audit"        value={relative(summary.last_audit_at)} />
    </div>
  );
}
